import React from 'react';
import {connect} from "react-redux";
import {TodayTasks} from "../../components/tasks/TodayTasks";
import {Redirect} from "react-router-dom";
import PageTitle from "../../Layout/AppMain/PageTitle";
import {tran} from "../../i18n_translations/translate";


class TodayTasksPage extends React.Component {
  render() {
    if (this.props.selectedPet === null) return <Redirect to={'/pets/list'} />

    return (
      <React.Fragment>
        <PageTitle
          heading={tran('Tasks for Today')}
        />
        <TodayTasks pet={this.props.selectedPet} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  selectedPet: state.PetOptions.selectedPet,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TodayTasksPage);
